import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

// Components
import Loader from 'app/views/components/Loader'

// Redux
import { resetQuiz } from 'app/state/modules/quiz'

// Utils
import analytics from 'app/views/utils/analytics'


class QuizReset extends React.Component {
  componentDidMount() {
    analytics.page('quiz-reset')
    if (this.props.isAuthenticated) {
      this.props.resetQuiz()
    } else {
      this.props.history.push('/login')
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isAuthenticated && nextProps.quiz.uuid) {
      this.props.history.push(`/quiz/${nextProps.quiz.uuid}`)
    }
  }

  render() {
    return (
      <Loader visible />
    )
  }
}


const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
  quiz: state.quiz.quiz,
})

const mapDispatchToProps = (dispatch) => ({
  resetQuiz: () => { dispatch(resetQuiz()) },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizReset))
